import { useState } from 'react';
import type { DisplayProduct, ProductClickHandler } from '../../types';
import { ProductGrid } from '../ProductGrid/ProductGrid';
import styles from './ProductLane.module.css';

interface ProductLaneProps {
  title: string;
  products: DisplayProduct[];
  subtitle?: string;
  /** Renders the header as a toggle and starts collapsed. */
  collapsible?: boolean;
  onProductClick?: ProductClickHandler;
}

export function ProductLane({
  title,
  products,
  subtitle,
  collapsible = false,
  onProductClick,
}: ProductLaneProps) {
  const [open, setOpen] = useState(!collapsible);
  if (products.length === 0) return null;

  const heading = (
    <>
      <h2 className={styles.title}>{title}</h2>
      <span className={styles.count}>{products.length}</span>
    </>
  );

  return (
    <section className={styles.lane}>
      {collapsible ? (
        <button type={'button'} className={styles.toggle} onClick={() => setOpen((v) => !v)}>
          {heading}
          <svg
            className={styles.chevron}
            data-open={open}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
      ) : (
        <div className={styles.head}>{heading}</div>
      )}

      {subtitle && open && <p className={styles.sub}>{subtitle}</p>}
      {open && <ProductGrid products={products} flush onProductClick={onProductClick} />}
    </section>
  );
}
